import { useState } from 'react'
import { PencilIcon } from '@heroicons/react/24/solid'
import { ArchiveBoxArrowDownIcon, ArchiveBoxXMarkIcon, TrashIcon } from '@heroicons/react/24/outline'

import ContactRoles from './ContactRoles'
import { formatPhoneNumber } from '@/utils/formatters'
import { SingleLineAddressOnListing } from '@/components/Address'
import EmailLink from '@/components/EmailLink'

export default ({contact, isPendingAction, isAnimating, 
  editClick = () => {}, 
  archiveClick = () => {},
  deleteClick = () => {}
}) => {
  const [ showConfirmDialog, setShowConfirmDialog ] = useState(false)

  const handleRowClick = (contactId) => {
    window.location.href = `/contacts/${contactId}` // Rediriger vers la page de détails du contact cliqué
  }
  const handleDeleteClick = () => {
    setShowConfirmDialog(true)
  }
  const confirmDelete = () => {
    deleteClick(contact.id)
    setShowConfirmDialog(false)
  }

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  const isArchived = !!contact?.archived_at

  return (
    <>
      <tr 
        data-id={contact.id}
        onClick={() => handleRowClick(contact.id)} 
        className={`cursor-pointer text-sm hover:bg-primary-200 transition-all duration-500 ${
          isAnimating 
            ? 'opacity-50 transform scale-98 translate-x-2' 
            : 'opacity-100 transform scale-100'
        }`}
      >
        <td className="p-1 uppercase">{contact.nom?.toUpperCase()}</td>
        <td className="p-1 uppercase">{contact.prenom}</td>
        <td className="p-1 uppercase"><SingleLineAddressOnListing data={contact} /></td>
        <td className="p-1 text-nowrap">{formatPhoneNumber(contact.telephone)}</td>
        <td className="p-1 text-nowrap"><EmailLink email={contact.email} /></td>
        <td className="p-1 text-nowrap"><ContactRoles roles={contact.roles} /></td>
        <td className="flex gap-2 p-1">
          <div>
            { !isPendingAction && (
              <button 
                className="btn btn-sm btn-ghost btn-square hover:bg-primary-400" 
                title="Modifier le contact"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  editClick(contact?.id)
                }}
              >
                <PencilIcon className="h-5 w-5" />
              </button>
            )}
            <button 
              id='archiveBtn' 
              className={`btn btn-sm btn-ghost btn-square hover:bg-primary-400 ${
                isPendingAction ? 'loading' : ''
              }`} 
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                if (!isPendingAction) {
                  archiveClick(contact?.id)
                }
              }}
              disabled={isPendingAction}
              title={`${isArchived ? "Restaurer" : "Archiver"} le contact`}
            >
              {!isPendingAction && (
                isArchived ? <ArchiveBoxXMarkIcon className="h-5 w-5" /> : <ArchiveBoxArrowDownIcon className="h-5 w-5" />
              )}
            </button>
            { !isPendingAction && !!isArchived && handleDeleteClick && (
                <button 
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    handleDeleteClick()
                  }} 
                  title="Supprimer le bien"
                  className="p-1 btn btn-sm btn-ghost btn-square hover:bg-primary-400">
                  <TrashIcon className="h-5 w-5" />
                </button>
              )}
          </div>
        </td>
      </tr>
      {showConfirmDialog && (
        <dialog open className="modal">
          <div className="modal-box">
            <h3 className="font-bold text-lg">Confirmer la suppression</h3>
            <p className="py-4">Êtes-vous sûr de vouloir supprimer ce contact ?</p>
            <p className="py-4 text-center">{contact.nom_complet}</p>
            <div className="modal-action">
              <button onClick={confirmDelete} className="btn btn-secondary">Supprimer</button>
              <button onClick={cancelDelete} className="btn btn-outline">Annuler</button>
            </div>
          </div>
        </dialog>
      )}
    </>
  )
}